import { ValidatorFn } from '@angular/forms';
import { AddressExistsValidator } from '@shared/validators/address/address-exists';

export class U2bAddressValidators {
    public static addressExists(message?: string): ValidatorFn {
        return new AddressExistsValidator(message).asValidatorFn();
    }
}
